var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 267 266",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#046cfc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.39,122.77q.26-3.37.68-6.71Q.65,119.39.39,122.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.42,163A133,133,0,0,1,.69,146.6,133,133,0,0,0,3.42,163Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.69,199.2A131.72,131.72,0,0,1,6,172.55,131.72,131.72,0,0,0,17.69,199.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,172.55c-1-3.12-1.84-6.3-2.58-9.51C4.16,166.25,5,169.43,6,172.55Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.06,96.59A132.49,132.49,0,0,1,21,61.31,132.49,132.49,0,0,0,5.06,96.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.07,116.06c.29-2.22.62-4.42,1-6.6C1.69,111.64,1.36,113.84,1.07,116.06Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,61.31A134.22,134.22,0,0,1,39.1,39,134.22,134.22,0,0,0,21,61.31Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.1,39q2.26-2.25,4.64-4.4Q41.37,36.69,39.1,39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.09,109.46a130.7,130.7,0,0,1,3-12.87A130.7,130.7,0,0,0,2.09,109.46Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.46,255.55q-3,1.26-6.06,2.38Q182.47,256.81,185.46,255.55Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261,172.55a131.72,131.72,0,0,1-11.69,26.65A131.72,131.72,0,0,0,261,172.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.58,163c-.74,3.21-1.61,6.39-2.58,9.51C262,169.43,262.84,166.25,263.58,163Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.38,239.58c-1.72,1.27-3.46,2.51-5.24,3.71C209.92,242.09,211.66,240.85,213.38,239.58Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.31,146.6A133,133,0,0,1,263.58,163,133,133,0,0,0,266.31,146.6Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.87,250c-1.9-1-3.76-2.09-5.59-3.2C66.11,247.86,68,248.92,69.87,250Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.86,243.29c-1.78-1.2-3.52-2.44-5.24-3.71C55.34,240.85,57.08,242.09,58.86,243.29Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.6,257.93q-3.07-1.12-6.06-2.38Q84.53,256.81,87.6,257.93Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.72,246.75c-1.83,1.11-3.69,2.17-5.59,3.2C199,248.92,200.89,247.86,202.72,246.75Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.58,30.37q2.47-2,5-3.95Q51.05,28.34,48.58,30.37Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.21,8.37c-1.29-.47-2.59-.94-3.89-1.38,1.3.44,2.6.91,3.89,1.38Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.69,199.2a133.9,133.9,0,0,0,35.93,40.38A133.9,133.9,0,0,1,17.69,199.2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.38,239.58a133.9,133.9,0,0,0,35.93-40.38A133.9,133.9,0,0,1,213.38,239.58Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.86,22.71q4-2.68,8.19-5.09Q62.85,20,58.86,22.71Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.94,96.59a130.7,130.7,0,0,1,3,12.87A130.7,130.7,0,0,0,261.94,96.59Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.91,109.46c.4,2.18.73,4.38,1,6.6C265.64,113.84,265.31,111.64,264.91,109.46Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.54,10.45Q86,8.56,90.68,7,86,8.55,81.54,10.45Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.93,116.06q.42,3.33.68,6.71Q266.36,119.4,265.93,116.06Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.93,116.06c-.29-2.22-.62-4.42-1-6.6a130.7,130.7,0,0,0-3-12.87,132.1,132.1,0,0,0-9.71-24.45l-5.48,7A123.81,123.81,0,0,1,259,133c0,68.93-56.3,125-125.5,125S8,201.93,8,133,64.3,8,133.5,8A125.37,125.37,0,0,1,175,15l5.21-6.66c-1.29-.47-2.59-.94-3.89-1.38A134.65,134.65,0,0,0,90.68,7Q86,8.55,81.54,10.45a131.8,131.8,0,0,0-14.49,7.17q-4.2,2.4-8.19,5.09c-1.78,1.2-3.52,2.44-5.24,3.71s-3.39,2.6-5,3.95-3.26,2.75-4.84,4.18-3.13,2.9-4.64,4.4A134.22,134.22,0,0,0,21,61.31a132.49,132.49,0,0,0-16,35.28,130.7,130.7,0,0,0-3,12.87c-.4,2.18-.73,4.38-1,6.6s-.51,4.46-.68,6.71C.13,126.14,0,129.56,0,133a133.05,133.05,0,0,0,3.42,30c.74,3.21,1.61,6.39,2.58,9.51A131.72,131.72,0,0,0,17.69,199.2a133.9,133.9,0,0,0,35.93,40.38c1.72,1.27,3.46,2.51,5.24,3.71s3.58,2.34,5.42,3.46,3.69,2.17,5.59,3.2q5.67,3.08,11.67,5.6,3,1.26,6.06,2.38a134.57,134.57,0,0,0,91.8,0q3.07-1.12,6.06-2.38,6-2.52,11.67-5.6c1.9-1,3.76-2.09,5.59-3.2s3.65-2.27,5.42-3.46,3.52-2.44,5.24-3.71a133.9,133.9,0,0,0,35.93-40.38A131.72,131.72,0,0,0,261,172.55c1-3.12,1.84-6.3,2.58-9.51A133.05,133.05,0,0,0,267,133c0-3.44-.13-6.86-.39-10.23Q266.36,119.4,265.93,116.06Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.cc99a7eb.svg";
export { ForwardRef as ReactComponent };